import jsencrypt from 'jsencrypt'
import CryptoJS from 'crypto-js'
const key = CryptoJS.enc.Utf8.parse("S9u978Q31NGPGc5H"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse("X83yESM9iShLxfwS"); //十六位十六进制数作为密钥偏移量

const encrypt = function(publicKey, str) {
  let jse = new jsencrypt()
  jse.setPublicKey(publicKey)
  return jse.encrypt(str)
}

// AES解密方法
export function Decrypt(word) {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

export default encrypt



// WEBPACK FOOTER //
// ./src/api/encrypt.js